import { PageTree, AppStyles } from "../app-context-provider";
import FileSaver from "file-saver";

export interface StylesResponse {
    styleObject: AppStyles;
    stylesheet: string;
}

export async function getPageTree(host: string): Promise<PageTree> {
    const req = await fetch("/headless/pagetree?domain=" + host, {
        mode: "no-cors", // no-cors, *cors, same-origin
        cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
        headers: {
            "Content-Type": "application/json",
            // 'Content-Type': 'application/x-www-form-urlencoded',
        },
    });

    const tree = await req.json();

    return tree;
}

export async function getStyles(id: number): Promise<StylesResponse> {
    const req = await fetch("/headless/cssVars?id=" + id, {
        mode: "no-cors", // no-cors, *cors, same-origin
        cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
        headers: {
            "Content-Type": "application/json",
            // 'Content-Type': 'application/x-www-form-urlencoded',
        },
    });

    const css = await req.json();

    return css;
}

export function getHost(): string {
    if (typeof window === undefined) {
        return "";
    }

    const host = window.location.hostname.split(":")[0];
    return host;
}

export async function getData(host: string): Promise<any> {
    const req = await fetch("/headless/pagedata?domain=" + host, {
        mode: "no-cors", // no-cors, *cors, same-origin
        cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
        headers: {
            "Content-Type": "application/json",
            // 'Content-Type': 'application/x-www-form-urlencoded',
        },
    });

    const data = await req.json();

    return data;
}

export async function getDataById(id: number): Promise<any> {
    const req = await fetch("/headless/pagedata?id=" + id, {
        mode: "no-cors", // no-cors, *cors, same-origin
        cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
        headers: {
            "Content-Type": "application/json",
            // 'Content-Type': 'application/x-www-form-urlencoded',
        },
    });

    const data = await req.json();

    return data;
}

export async function getChildren(id: number): Promise<any> {
    const req = await fetch("/headless/children?id=" + id, {
        mode: "no-cors", // no-cors, *cors, same-origin
        cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
        headers: {
            "Content-Type": "application/json",
            // 'Content-Type': 'application/x-www-form-urlencoded',
        },
    });

    const data = await req.json();

    return data;
}

export async function convertImage(id: number): Promise<any> {
    const req = await fetch("/headless/images/fromfile?id=" + id, {
        mode: "no-cors", // no-cors, *cors, same-origin
        cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
        headers: {
            "Content-Type": "application/json",
            // 'Content-Type': 'application/x-www-form-urlencoded',
        },
    });

    console.log(req);
    const data = await req.json();

    return data;
}

export async function getZip(
    Ids: number[],
    Format: string,
    filename: string,
    updateCallback: Function,
    doneCallback: Function
): Promise<any> {
    const data = { Ids, Format };

    const response = await fetch("/zip/fromids", {
        method: "POST", // *GET, POST, PUT, DELETE, etc.
        //mode: 'no-cors', // no-cors, *cors, same-origin
        cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
        headers: {
            "Content-Type": "application/json",
            // 'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: JSON.stringify(data), // body data type must match "Content-Type" header
    });

    //const result = await req.blob();

    const reader = response?.body?.getReader();
    // Step 2: get total length
    const contentLength = +response.headers.get("Content-Length")!;
    console.log(contentLength);
    if (reader !== undefined) {
        let receivedLength = 0; // received that many bytes at the moment
        let chunks = []; // array of received binary chunks (comprises the body)

        // infinite loop while the body is downloading
        while (true) {
            // done is true for the last chunk
            // value is Uint8Array of the chunk bytes
            const { done, value } = await reader.read();

            if (value === undefined) {
                break;
            }

            chunks.push(value);
            receivedLength += value.length;
            const recievedPercent = (receivedLength / contentLength) * 100;

            if (typeof updateCallback === "function") {
                updateCallback(recievedPercent.toFixed(0));
            }

            if (done) {
                break;
            }
        }
        if (typeof doneCallback === "function") {
            doneCallback();
        }
        console.log(response.headers.get("content-disposition")?.split("."));

        // let a = document.createElement("a");
        // document.body.appendChild(a);
        // let blob = new Blob(chunks);
        // let url = window.URL.createObjectURL(blob);
        // a.href = url;
        // a.download =
        //     filename +
        //     (Ids.length > 1
        //         ? ".zip"
        //         : "." +
        //           response.headers.get("content-disposition")?.split(".")[1]);
        // a.click();
        // document.body.removeChild(a);
        // window.URL.revokeObjectURL(url);
        let mime = require("mime-types");
        const blob = new Blob(chunks, {
            type: `${mime.lookup(
                "." + response.headers.get("content-disposition")?.split(".")[1]
            )}`,
        });
        const url = window.URL.createObjectURL(blob);

        FileSaver.saveAs(
            url,
            `${filename}${
                Ids.length > 1
                    ? ".zip"
                    : "." +
                      response.headers.get("content-disposition")?.split(".")[1]
            }`
        );

        // this.setState({ downloadStatus: 0 });
    }

    // var myHeaders = new Headers();
    // myHeaders.append("Content-Type", "application/json");

    // var raw = JSON.stringify({ "Ids": [1473, 1469], "Format": "jpg" });

    // var requestOptions: RequestInit = {
    //   method: 'POST',
    //   headers: myHeaders,
    //   body: raw,
    //   redirect: 'follow', // manual, *follow, error
    //   mode: 'no-cors', // no-cors, *cors, same-origin
    //   cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
    // };

    // const req = await fetch("/zip/fromids", requestOptions)
    // const result = await req.blob();
}
